export class PoliticalUnit {
  id: string;
  uri: string;
  name: string;

  constructor(
    id: string,
    name: string,
    uri?: string
  ) {
    this.id = id;
    this.uri = uri;
    this.name = name;
  }
}
